import $ from "jquery";
import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.


// You will need a ResizeObserver polyfill for browsers that don't support it! (iOS Safari, Edge, ...)
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;

(function($, window, document) {

    "use strict";

    // Main Menu
    var TLS_Menu = function () {

        var self = this;

        this.menu_init = function () {
            // var agent = window.navigator.userAgent;
            // var browser = agent.split(/[, ]+/).pop();

            // alert(browser.split("/")[0]);
            // if (browser.split("/")[0] == 'Safari'){

            // }
            // Evita chiusura menu al click sopra
            $(".dropdown-menu").click(function (event) {
                event.stopPropagation();
            });
            $(".nav-expand-link").click(function (event) {
              event.preventDefault();
            });
            $(".close__wrapper__subsub-list").click(function(event) {
               $(this).closest('.dropdown-menu').removeClass("show");
            });

            // Mobile menu (multilevel)
            var navExpand = [].slice.call(document.querySelectorAll('.nav-expand'))
            var backLink = `<li class="nav-item nav-back-item">
            <a class="nav-link nav-back-link p-4" href="javascript:;">
                Indietro
            </a>
            </li>`

            navExpand.forEach(item => {
            item.querySelector('.nav-expand-content').insertAdjacentHTML('afterbegin', backLink)
            item.querySelector('.nav-link').addEventListener('click', () => item.classList.add('active'))
            item.querySelector('.nav-back-link').addEventListener('click', () => item.classList.remove('active'))
            })

            var ham = document.getElementById('hamburger')
            ham.addEventListener('click', function() {
            document.body.classList.toggle('nav-is-toggled')
            })
            var hamClose = document.getElementById('nav-close')
            hamClose.addEventListener('click', function() {
            document.body.classList.toggle('nav-is-toggled')
            })
        }

        this.bind = function () {
            $( document ).ready( self.menu_init );			
        };
      
        this.init = function () {	
            self.bind();
        };
      
        this.init();

    };

    // Footer Menu
    var TLS_Footer_Menu = function () {

        var self = this;

        this.menu_init = function () {
            var footerMenu = $('#site-footer .nav-footer');
            var footerMenuToggle = footerMenu.prev('.nav-footer-title');

            if(footerMenu.is(":hidden")){

                $(footerMenuToggle).on('click', function(e){
                    e.preventDefault();
                    $(this).toggleClass('active');
                    $(this).next('.nav-footer').toggleClass('d-none');
                });

            }

        };

        this.bind = function () {
            $( document ).ready( self.menu_init );			
        };
      
        this.init = function () {	
            self.bind();
        };
      
        this.init();
    };
      
    (new TLS_Menu());
    (new TLS_Footer_Menu());

}(window.jQuery, window, document));